import { useContext } from 'react'
import { PassContext } from "../../../pass-context"
import dataSelector from '../../data-selector'
import PopupEditor from '../../popup-editor'

import { useState } from "react"
import BwipJs from "@bwip-js/browser"

export default () => {
  try {
    const { classData, objectData, instanceData, scannerInstanceData, isSmartixScannerPass } = useContext(PassContext)
    const barcodeData = dataSelector({ objectData, instanceData, scannerInstanceData, path: "barcode" })

    let [img, setImg] = useState(null)
    let [barcodeValue, setBarcodeValue] = useState(null)
    let [barcodeType, setBarcodeType] = useState(null)

    if (isSmartixScannerPass || (barcodeData && barcodeData.value?.length && barcodeData.type !== "NONE")) {
      if (!img || barcodeValue !== barcodeData?.value || barcodeType !== barcodeData?.type) {
        let canvas = document.createElement('canvas');

        BwipJs.toCanvas(canvas, { ...options[isSmartixScannerPass ? "QR_CODE" : barcodeData?.type], text: barcodeData?.value ?? "dummy barcode value"})

        let barcode = canvas.toDataURL('image/png')

        setImg(barcode)
        setBarcodeType(barcodeData?.type)
        setBarcodeValue(barcodeData?.value)
      }
    } else {
      if (img) {
        setImg(null)
        setBarcodeType(null)
        setBarcodeValue(null)
      }
    }

    let securityAnimationClass

    if (classData.securityAnimation?.animationType && barcodeData.type !== "NONE") {
      // Show security animation shimmer
      securityAnimationClass = "googleBarcodeSecurityAnimation"
    }

    return (
      <div className="flex flex-row w-full p-3 justify-center" >
      <PopupEditor title="Barcode" type="barcode" disabled={isSmartixScannerPass}>
        <div className="barcode editable" style={{ minWidth: 150, minHeight: 20, padding:2 }}>
          {barcodeData && barcodeData.type !== "NONE" &&
            <div className={securityAnimationClass}>
              <div className={`bg-white text-center w-fit text-black rounded-md ${barcodeShapes[barcodeData?.type]}`}>
                <img src={img} style={{ width: barcodeWidths[isSmartixScannerPass ? "QR_CODE" : barcodeData?.type], height: barcodeHeigths[isSmartixScannerPass ? "QR_CODE" : barcodeData?.type], margin: "auto" }} />
                <div className="text">{barcodeData?.alternateText ?? '000-000-000'}</div>
              </div>
            </div>
          }
        </div>
      </PopupEditor>
    </div>
    )
  }

  catch (err) {
    throw err
  }
}

const barcodeShapes = {
  AZTEC: "square",
  QR_CODE: "square",
  PDF_417: "linear",
  CODE_128: "linear",
}

const barcodeWidths = {
  AZTEC: 150,
  QR_CODE: 150,
  PDF_417: 300, 
  CODE_128: 300,
  undefined: 150
}

const barcodeHeigths = {
  AZTEC: 144,
  QR_CODE: 144,
  PDF_417: 120, 
  CODE_128: 120,
  undefined: 20
}

const options = {
  AZTEC: {
    bcid: 'azteccode',
    scale: 1,
    includetext: false,
    eclevel: 23,
    ecaddchars: 3,
    layers: 8,
    width: 60,
    height: 60,
    padding: 0,
    paddingbottom: 5,
  },
  QR_CODE: {
    bcid: 'qrcode',
    scale: 1,
    includetext: false,
    eclevel: "M",
    ecaddchars: 3,
    layers: 8,
    width: 60,
    height: 60,
    padding: 20,
    paddingbottom: 21,
  },
  PDF_417: {
    bcid: 'pdf417',
    scale: 1,
    includetext: false,
    width: 250,
    height: 50,
    padding: 20,
  },
  CODE_128: {
    bcid: 'code128',
    scale: 1,
    width: 250,
    height: 50,
    includetext: false,
    paddingbottom: 21,
  }
}